module.exports = __webpack_public_path__ + "img/blue_102.f40210bb.png";